import { constants } from 'consts'

export const createImageUrl = (id) => `${constants.API_BASE_URI}/Image/Get/${id}`
